import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightbox"]

  openLightbox(event) {
    const targetId = event.params.target
    const lightbox = document.getElementById(targetId)
    if (lightbox) lightbox.classList.add("is-open")
  }

  closeLightbox(event) {
    event.stopPropagation()
    event.target.closest(".video-lightbox").classList.remove("is-open")
  }

  closeLightboxBackground(event) {
    if (event.target === event.currentTarget) {
      event.currentTarget.classList.remove("is-open")
    }
  }
}
